
function downloadPageResource(e) {
  if(e) {
  	e.preventDefault();
  }

  const thisAnchor = e.target.closest('a');

  const url=thisAnchor.getAttribute('href');
  const filename=thisAnchor.getAttribute('title');
  const thisParent = thisAnchor.closest('.item-link');

  thisParent.innerHTML = '<div class="download-resource loading"><span>Preparing to download '+filename+'&hellip;</span><div class="button-overlay-spinner"><span class="spinner-xs"></span></div></div>';

  fetch(url, {
      headers: new Headers({
        'Origin': location.origin
      }),
      mode: 'cors'
    })
    .then(response => response.blob())
    .then(blob => {
      let blobUrl = window.URL.createObjectURL(blob);
      thisParent.innerHTML = '<div class="download-success"><span>'+filename+' successfully downloaded</span><div class="icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5303 7.53033C20.8232 7.23744 20.8232 6.76256 20.5303 6.46967C20.2374 6.17678 19.7626 6.17678 19.4697 6.46967L20.5303 7.53033ZM9.00004 18L8.46972 18.5303C8.76261 18.8232 9.23748 18.8232 9.53037 18.5303L9.00004 18ZM4.53026 12.4697C4.23736 12.1768 3.76249 12.1768 3.4696 12.4697C3.17671 12.7626 3.17672 13.2374 3.46962 13.5303L4.53026 12.4697ZM19.4697 6.46967L8.46971 17.4696L9.53037 18.5303L20.5303 7.53033L19.4697 6.46967ZM3.46962 13.5303L8.46972 18.5303L9.53036 17.4696L4.53026 12.4697L3.46962 13.5303Z" fill="#001A72"/></svg></div></div>';
      forcePageDownload(blobUrl, filename);
    })
    .catch(e => console.error(e));
}

function forcePageDownload(blob, filename) {
  var a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  document.body.appendChild(a);
  a.click();
  a.remove();
}



const allDownloadButtons = document.querySelectorAll('.product-attachment-container .downloads-item a');
if (allDownloadButtons.length > 0) {
  for (i = 0; i < allDownloadButtons.length; i++) {
    allDownloadButtons[i].onclick = downloadPageResource;
  }
}